export default "__VITE_ASSET__DfQH8O5Q__"